module.exports = __webpack_public_path__ + "media/images/banners/bg7-f636d1191864f2e4cd51100ee7faad1a.png";